import type { ApprovalDetails, PendingApprovalItem, N8NStatusResponse, InAppApprovalResponse } from '../shared/types';
import { authenticatedFetch } from '../shared/authenticatedFetch';

export async function getApprovalDetails(apiUrl: string, reviewId: string): Promise<ApprovalDetails | null> {
  const response = await authenticatedFetch(
    `${apiUrl}/projects/approval-details?reviewId=${encodeURIComponent(reviewId)}`
  );

  const data = await response.json();
  return data;
}

export async function approveProjectInApp(
  apiUrl: string,
  areaLevel1: string,
  fiscalYearQuarter: string,
): Promise<InAppApprovalResponse> {
  const response = await authenticatedFetch(
    `${apiUrl}/approvals/in-app/approve?areaLevel1=${encodeURIComponent(areaLevel1)}&fiscalYearQuarter=${encodeURIComponent(fiscalYearQuarter)}`,
    { method: 'POST' },
  );
  return response.json();
}

export async function reopenProject(
  apiUrl: string,
  areaLevel1: string,
  fiscalYearQuarter: string,
): Promise<InAppApprovalResponse> {
  const response = await authenticatedFetch(
    `${apiUrl}/approvals/in-app/reopen?areaLevel1=${encodeURIComponent(areaLevel1)}&fiscalYearQuarter=${encodeURIComponent(fiscalYearQuarter)}`,
    { method: 'POST' },
  );
  return response.json();
}


export async function getPendingApprovals(apiUrl: string): Promise<PendingApprovalItem[]> {
  const response = await authenticatedFetch(`${apiUrl}/approvals/in-app/pending`);
  return response.json();
}

export async function getN8NStatus(apiUrl: string): Promise<N8NStatusResponse> {
  const response = await authenticatedFetch(`${apiUrl}/approvals/in-app/n8n-status`);
  return response.json();
}
